import { Buffer as BufferPolyfill } from 'buffer';
import SuperJSON from 'superjson';

export const superjsonCodec = new SuperJSON();

superjsonCodec.registerCustom(
  {
    isApplicable: (value) => BufferPolyfill.isBuffer(value),
    serialize: (value) => value.toString('base64'),
    deserialize: (value) => BufferPolyfill.from(value, 'base64')
  },
  'buffer'
);
